import React, { useState, useEffect } from "react";
import { API_BASE_URL } from "./config";
import axios from "axios";
// import { ToastContainer } from "react-toastify";
import { Row, Col, Button, Modal } from "react-bootstrap";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import InputMask from "react-input-mask";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useLocation, useNavigate } from "react-router-dom";

// const CadastroUsuarioModal = ({ closeModal, escolas = [] }) => {
const CadastroUsuarioModal = ({ userId }) => {
    // const { id } = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const goBack = () => {
        const from = location.state?.from;
        if (typeof from === "string" && from.startsWith("/")) {
            navigate(from, { replace: true });
            return;
        }
        navigate("/usuarios");
    };

    const [userData, setUserData] = useState({
        cp_nome: "",
        cp_email: "",
        cp_login: "",
        cp_password: "",
        cp_tipo_user: "",
        cp_rg: "",
        cp_cpf: "",
        cp_datanascimento: "",
        cp_estadocivil: "",
        cp_cnpj: "",
        cp_ie: "",
        cp_whatsapp: "",
        cp_telefone: "",
        cp_empresaatuacao: "",
        cp_profissao: "",
        cp_end_cidade_estado: "",
        cp_end_rua: "",
        cp_end_num: "",
        cp_end_cep: "",
        cp_descricao: "",
        cp_escola_id: "",
        cp_foto_perfil: null,
    });
    // const [errorMessage, setErrorMessage] = useState('');
    // const [successMessage, setSuccessMessage] = useState('');
    const [isEmpresa, setIsEmpresa] = useState(false);
    const [userType, setUserType] = useState(null);
    const [showPassword, setShowPassword] = useState(false);
    const [confirmPassword, setConfirmPassword] = useState("");
    const [confirmPasswordError, setConfirmPasswordError] = useState("");
    const [fieldErrors, setFieldErrors] = useState({});
    const [escolas, setEscolas] = useState([]);
    const [showModal, setShowModal] = useState(false);

    const handleShowModal = () => setShowModal(true);
    const handleCloseModal = () => setShowModal(false);
    const clearFieldError = (fieldName) => {
        setFieldErrors((prevErrors) => {
            if (!prevErrors[fieldName]) return prevErrors;
            const nextErrors = { ...prevErrors };
            delete nextErrors[fieldName];
            return nextErrors;
        });
    };
    const getUserFieldLabel = (fieldName) => {
        const labels = {
            cp_nome: "Nome",
            cp_email: "E-mail",
            cp_login: "Login",
            cp_password: "Senha",
            cp_tipo_user: "Tipo de usuário",
            cp_escola_id: "Escola",
            cp_rg: "RG",
            cp_cpf: "CPF",
            cp_datanascimento: "Data de nascimento",
            cp_estadocivil: "Estado civil",
            cp_whatsapp: "WhatsApp",
            cp_telefone: "Telefone",
            cp_end_cidade_estado: "Cidade e estado",
            cp_end_rua: "Rua",
            cp_end_num: "Endereço com número",
            cp_end_cep: "CEP",
            cp_descricao: "Descrição",
            cp_cnpj: "CNPJ",
            cp_ie: "Inscrição estadual",
            cp_empresaatuacao: "Empresa de atuação",
            cp_profissao: "Profissão"
        };

        return labels[fieldName] || fieldName;
    };
    const formatFieldErrorMessage = (fieldName, fallbackMessage) => {
        if (!fieldName) return fallbackMessage;

        const fieldLabel = getUserFieldLabel(fieldName);
        const normalizedMessage = String(fallbackMessage || "").toLowerCase();

        if (normalizedMessage.includes("obrigat")) {
            return `Campo ${fieldLabel} obrigatório.`;
        }

        if (normalizedMessage.includes("ja existe") || normalizedMessage.includes("já existe")) {
            return `Campo ${fieldLabel} já cadastrado.`;
        }

        if (
            normalizedMessage.includes("fora do intervalo") ||
            normalizedMessage.includes("excede o tamanho permitido") ||
            normalizedMessage.includes("inval")
        ) {
            return `Campo ${fieldLabel} inválido.`;
        }

        return `Campo ${fieldLabel} inválido.`;
    };
    const getFieldClassName = (fieldName, baseClassName = "form-control") =>
        fieldErrors[fieldName] ? `${baseClassName} is-invalid` : baseClassName;
    const renderFieldError = (fieldName) =>
        fieldErrors[fieldName]
            ? <div className="invalid-feedback d-block">{fieldErrors[fieldName]}</div>
            : null;

    useEffect(() => {
        const fetchEscolas = async () => {
            try {
                const response = await axios.get(`${API_BASE_URL}/escolas`, {
                    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
                });
                setEscolas(response.data);
            } catch (error) {
                console.error("Erro ao buscar escolas:", error);
            }
        };
        fetchEscolas();
    }, []);

    useEffect(() => {
        if (userId) {
            axios.get(`${API_BASE_URL}/users/${userId}`, {
                headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
            })
                .then(response => {
                    const data = response.data;
                    const normalizedData = {
                        ...data,
                        cp_whatsapp: stripNonDigits(data.cp_whatsapp),
                        cp_telefone: stripNonDigits(data.cp_telefone),
                        cp_end_cep: stripNonDigits(data.cp_end_cep),
                        cp_cnpj: stripNonDigits(data.cp_cnpj)
                    };

                    if (normalizedData.cp_datanascimento) {
                        normalizedData.cp_datanascimento = formatarDataParaExibicao(normalizedData.cp_datanascimento);
                    }
                    setUserData(normalizedData); // Preenche o formulário
                    setConfirmPassword(normalizedData.cp_password || "");

                })
                .catch(error => {
                    console.error("Erro ao buscar usuário:", error);
                    toast.error("Erro ao carregar os dados do usuário.");
                });
        }
    }, [userId]);


    useEffect(() => {
        const userTypeFromStorage = localStorage.getItem("userType");
        setUserType(parseInt(userTypeFromStorage, 10));
    }, []);

    useEffect(() => {
        if (!userId) {
            const escolaId = localStorage.getItem("schoolId");
            setUserData((prev) => ({ ...prev, cp_escola_id: escolaId }));
        }
    }, []);


    const getFilteredOptions = () => {
        const options = [
            { value: "1", label: "Gestor" },
            { value: "2", label: "Diretor" },
            { value: "3", label: "Secretária" },
            { value: "4", label: "Professor" },
            { value: "5", label: "Aluno" },
        ];

        return options.filter((option) => parseInt(option.value, 10) >= userType);
    };

    const isValidCalendarDate = (year, month, day) => {
        if (!Number.isInteger(year) || !Number.isInteger(month) || !Number.isInteger(day)) return false;
        if (month < 1 || month > 12 || day < 1 || day > 31) return false;

        const date = new Date(Date.UTC(year, month - 1, day));
        return (
            date.getUTCFullYear() === year &&
            date.getUTCMonth() === month - 1 &&
            date.getUTCDate() === day
        );
    };

    const formatarDataParaExibicao = (dataString) => {
        if (!dataString) return "";
        // Se já estiver em dd/mm/yyyy, retorna
        if (/^\d{2}\/\d{2}\/\d{4}$/.test(dataString)) return dataString;
        
        // Tenta processar yyyy-mm-dd (com ou sem hora)
        if (typeof dataString === 'string' && dataString.includes('-')) {
             const datePart = dataString.split('T')[0];
             // NÃO usa timezone para evitar problemas de conversão com datas sem horário
             // Apenas formata a data diretamente
             const [ano, mes, dia] = datePart.split('-');
             return `${dia}/${mes}/${ano}`;
        }
        
        return "";
    };

    const formatarDataParaEnvio = (dataString) => {
        if (!dataString) return null;
        // Espera formato dd/mm/yyyy
        if (/^\d{2}\/\d{2}\/\d{4}$/.test(dataString)) {
            const [dia, mes, ano] = dataString.split('/');
            const day = parseInt(dia, 10);
            const month = parseInt(mes, 10);
            const year = parseInt(ano, 10);
            if (!isValidCalendarDate(year, month, day)) return null;
            return `${ano}-${mes}-${dia}`;
        }
        // Se já estiver em yyyy-mm-dd, retorna
        if (/^\d{4}-\d{2}-\d{2}$/.test(dataString)) {
            const [ano, mes, dia] = dataString.split('-');
            const day = parseInt(dia, 10);
            const month = parseInt(mes, 10);
            const year = parseInt(ano, 10);
            if (!isValidCalendarDate(year, month, day)) return null;
            return dataString;
        }

        return null;
    };

    const stripNonDigits = (value) => {
        if (value === undefined || value === null) return "";
        return String(value).replace(/\D+/g, "");
    };

    // Adicione esta verificação antes de enviar o formulário:
    // if (userData.cp_password !== confirmPassword) {
    //   toast.error("As senhas não coincidem.");
    //   return;
    // }

    const handleChange = (e) => {
        const { name, value, files } = e.target;
        if (name === "cp_foto_perfil") {
            setUserData((prevUserData) => ({
                ...prevUserData,
                [name]: files[0], // Armazena o arquivo de foto de perfil
            }));
        } else {
            // Limitar comprimento do WhatsApp para evitar erro de banco de dados
            let processedValue = value;
            const digitOnlyFields = new Set(["cp_whatsapp", "cp_telefone", "cp_end_cep", "cp_cnpj"]);
            if (digitOnlyFields.has(name)) {
                processedValue = stripNonDigits(value);
            }
            if (name === "cp_whatsapp" && processedValue.length > 20) {
                processedValue = processedValue.substring(0, 20);
            }
            clearFieldError(name);
             
            setUserData((prevUserData) => ({
                ...prevUserData,
                [name]: processedValue,
            }));
        }
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        setFieldErrors({});

        if (!userData.cp_tipo_user) {
            toast.error("Tipo de usuário é obrigatório.");
            return;
        }
        if (confirmPassword && userData.cp_password !== confirmPassword) {
            toast.error("As senhas não coincidem.");
            return;
        }

        const dataNascimentoFormatada = formatarDataParaEnvio(userData.cp_datanascimento);
        if (!dataNascimentoFormatada) {
            toast.error("Data de nascimento invalida. Use uma data real no formato dd/mm/aaaa.");
            return;
        }

        const dataToSend = {
            ...userData,
            cp_datanascimento: dataNascimentoFormatada,
            cp_whatsapp: stripNonDigits(userData.cp_whatsapp),
            cp_telefone: stripNonDigits(userData.cp_telefone),
            cp_end_cep: stripNonDigits(userData.cp_end_cep),
            cp_cnpj: stripNonDigits(userData.cp_cnpj)
        };

        try {
            if (userId) {
                // Modo de edição: Enviar como JSON, pois o backend espera JSON e não FormData
                const response = await axios.put(`${API_BASE_URL}/edit-user/${userId}`, dataToSend, {
                    headers: { 
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${localStorage.getItem('token')}`
                    }, // Alterado para JSON
                });

                if (response.status === 200) {
                    toast.success("Usuário editado com sucesso!");
                    handleCloseModal();
                    goBack();
                } else {
                    toast.error("Erro ao editar usuário.");
                }
            } else {
                // Modo de cadastro: Criar novo usuário
                const formData = new FormData();
                if (dataToSend.cp_foto_perfil) {
                    formData.append("cp_foto_perfil", dataToSend.cp_foto_perfil);
                }
                Object.keys(dataToSend).forEach((chave) => {
                    if (chave !== "cp_foto_perfil") {
                        const value = dataToSend[chave];
                        if (value !== undefined && value !== null && value !== "") {
                            formData.append(chave, value);
                        }
                    }
                });


                const response = await axios.post(`${API_BASE_URL}/register`, formData, {
                    headers: { 
                        "Content-Type": "multipart/form-data",
                        "Authorization": `Bearer ${localStorage.getItem('token')}`
                    }, // Mantém para cadastro
                });

                if (response.data.exists) {
                    toast.error("Usuário já cadastrado");
                    handleCloseModal();
                } else {
                    toast.success("Usuário cadastrado com sucesso!");
                    handleCloseModal();
                    goBack();
                }
            }
        } catch (error) {
            console.error("Erro ao salvar:", error.response?.data || error.message);
            const validationErrors = Array.isArray(error.response?.data?.errors)
                ? error.response.data.errors.filter((item) => item?.field && item?.message)
                : [];
            const mappedFieldErrors = validationErrors.reduce((acc, item) => {
                acc[item.field] = formatFieldErrorMessage(item.field, item.message);
                return acc;
            }, {});
            const responseField = error.response?.data?.field;
            const responseMsg = error.response?.data?.msg;
            if (responseField && responseMsg) {
                mappedFieldErrors[responseField] = formatFieldErrorMessage(responseField, responseMsg);
            }
            setFieldErrors(mappedFieldErrors);
            const validationError = validationErrors.find((item) => item?.message);
            const formattedValidationError = validationError
                ? formatFieldErrorMessage(validationError.field, validationError.message)
                : null;
            const serverError = responseField && responseMsg
                ? formatFieldErrorMessage(responseField, responseMsg)
                : formattedValidationError || error.response?.data?.error || error.response?.data?.msg;
            toast.error(serverError || "Erro ao salvar usuário. Tente novamente.");
        }
    };


    return (
        <div>
            <ToastContainer />
            <form className="form-container-cad" onSubmit={handleSubmit}>
                <style>{`
                    @media (max-width: 1446px) {
                        .password-col {
                            flex: 0 0 100%;
                            max-width: 100%;
                        }
                    }
                `}</style>
                <Row>
                    <Col md={6}>
                        {/* Coluna da Esquerda */}
                        <div className="card mb-3">
                            <div className="card-header">
                                <h6 className="card-title mb-0">Dados de Login</h6>
                            </div>
                            <div className="card-body">
                                <Row className="gy-3">
                                    <Col md={12}>
                                        <label htmlFor="cp_nome">Nome<span className="required">*</span>:</label>
                                        <input
                                            type="text"
                                            id="cp_nome"
                                            name="cp_nome"
                                            value={userData.cp_nome}
                                            onChange={handleChange}
                                            className={getFieldClassName("cp_nome")}
                                            placeholder="Nome"
                                            required
                                        />
                                        {renderFieldError("cp_nome")}
                                    </Col>
                                    <Col md={12}>
                                        <label htmlFor="cp_email">E-mail<span className="required">*</span>:</label>
                                        <input
                                            type="email"
                                            id="cp_email"
                                            name="cp_email"
                                            value={userData.cp_email}
                                            onChange={handleChange}
                                            className={getFieldClassName("cp_email")}
                                            placeholder="E-mail"
                                            required
                                        />
                                        {renderFieldError("cp_email")}
                                    </Col>
                                    <Col md={12}>
                                        <label htmlFor="cp_login">Login<span className="required">*</span>:</label>
                                        <input
                                            type="text"
                                            id="cp_login"
                                            name="cp_login"
                                            value={userData.cp_login}
                                            onChange={handleChange}
                                            className={getFieldClassName("cp_login")}
                                            placeholder="Login"
                                            required
                                        />
                                        {renderFieldError("cp_login")}
                                    </Col>
                                    <Col md={12}>
                                        <Row className="gy-3">
                                            <Col md={6} className="password-col">
                                                <label htmlFor="cp_password">Senha<span className="required">*</span>:</label>
                                                <div
                                                    className="position-relative w-100"
                                                    style={{ overflow: "hidden" }}
                                                >
                                                    <input
                                                        type={showPassword ? "text" : "password"}
                                                        id="cp_password"
                                                        name="cp_password"
                                                        value={userData.cp_password}
                                                        onChange={handleChange}
                                                        className={getFieldClassName("cp_password", "form-control w-100")}
                                                        placeholder="Senha"
                                                        required
                                                        style={{ paddingRight: "44px" }}
                                                    />
                                                    <button
                                                        type="button"
                                                        onClick={() => setShowPassword(!showPassword)}
                                                        className="btn p-0 position-absolute top-50 translate-middle-y"
                                                        style={{
                                                            right: "10px",
                                                            height: "28px",
                                                            width: "28px",
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                            color: "var(--dark-2)"
                                                        }}
                                                        aria-label={showPassword ? "Ocultar senha" : "Mostrar senha"}
                                                    >
                                                        {showPassword ? <FaEyeSlash /> : <FaEye />}
                                                    </button>
                                                </div>
                                                {renderFieldError("cp_password")}
                                            </Col>
                                            <Col md={6} className="password-col">
                                                <label htmlFor="cp_confirm_password">Confirmar Senha<span className="required">*</span>:</label>
                                                <div
                                                    className="position-relative w-100"
                                                    style={{ overflow: "hidden" }}
                                                >
                                                    <input
                                                        type={showPassword ? "text" : "password"}
                                                        id="cp_confirm_password"
                                                        name="cp_confirm_password"
                                                        value={confirmPassword}
                                                        onChange={(e) => {
                                                            setConfirmPassword(e.target.value);
                                                            setConfirmPasswordError("");
                                                        }}
                                                        onBlur={() => {
                                                            if (userData.cp_password && confirmPassword && userData.cp_password !== confirmPassword) {
                                                                setConfirmPasswordError("As senhas não coincidem.");
                                                            }
                                                        }}
                                                        className="form-control w-100"
                                                        placeholder="Confirmar senha"
                                                        required
                                                        style={{ paddingRight: "44px" }}
                                                    />
                                                    <button
                                                        type="button"
                                                        onClick={() => setShowPassword(!showPassword)}
                                                        className="btn p-0 position-absolute top-50 translate-middle-y"
                                                        style={{
                                                            right: "10px",
                                                            height: "28px",
                                                            width: "28px",
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                            color: "var(--dark-2)"
                                                        }}
                                                        aria-label={showPassword ? "Ocultar senha" : "Mostrar senha"}
                                                    >
                                                        {showPassword ? <FaEyeSlash /> : <FaEye />}
                                                    </button>
                                                </div>
                                                {confirmPasswordError && (
                                                    <small className="text-danger">{confirmPasswordError}</small>
                                                )}
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col md={12}>
                                        <label htmlFor="cp_tipo_user">Tipo de Usuário<span className="required">*</span>:</label>
                                        <select
                                            id="cp_tipo_user"
                                            name="cp_tipo_user"
                                            value={userData.cp_tipo_user}
                                            onChange={handleChange}
                                            className={getFieldClassName("cp_tipo_user")}
                                            required
                                        >
                                            <option value="">Selecione o tipo de usuário</option>
                                            {getFilteredOptions().map((option) => (
                                                <option key={option.value} value={option.value}>
                                                    {option.label}
                                                </option>
                                            ))}
                                        </select>
                                        {renderFieldError("cp_tipo_user")}
                                    </Col>
                                    <Col md={12}>
                                        <label htmlFor="cp_escola_id">Escola<span className="required">*</span>:</label>
                                        <select
                                            id="cp_escola_id"
                                            name="cp_escola_id"
                                            value={userData.cp_escola_id}
                                            // value={userData.cp_escola_id || localStorage.getItem("schoolId")}
                                            onChange={handleChange}
                                            className={getFieldClassName("cp_escola_id")}
                                            required
                                        >
                                            <option value="">Selecione a escola</option>
                                            {escolas.length > 0 ? (
                                                escolas.map((escola) => (
                                                    <option key={escola.cp_ec_id} value={escola.cp_ec_id}>
                                                        {escola.cp_ec_nome}
                                                    </option>
                                                ))
                                            ) : (
                                                <option value="" disabled>Carregando escolas...</option>
                                            )}
                                        </select>
                                        {renderFieldError("cp_escola_id")}
                                    </Col>
                                </Row>
                            </div>
                        </div>

                        <div className="card mt-4 mb-3">
                            <div className="card-header">
                                <h6 className="card-title mb-0">Dados Pessoais</h6>
                            </div>
                            <div className="card-body">
                                <Row className="gy-3">
                                    <Col md={12}>
                                        <label htmlFor="cp_rg">RG:</label>
                                        <input
                                            type="text"
                                            id="cp_rg"
                                            name="cp_rg"
                                            value={userData.cp_rg}
                                            onChange={handleChange}
                                            className={getFieldClassName("cp_rg")}
                                            placeholder="RG"
                                        />
                                        {renderFieldError("cp_rg")}
                                    </Col>
                                    <Col md={12}>
                                        <label htmlFor="cp_cpf">CPF<span className="required">*</span>:</label>
                                        <InputMask
                                            type="text"
                                            id="cp_cpf"
                                            name="cp_cpf"
                                            mask="999.999.999-99"
                                            value={userData.cp_cpf}
                                            onChange={handleChange}
                                            className={getFieldClassName("cp_cpf")}
                                            placeholder="CPF"
                                            required
                                        />
                                        {renderFieldError("cp_cpf")}
                                    </Col>
                                    <Col md={12}>
                                        <label htmlFor="cp_datanascimento">Data de Nascimento<span className="required">*</span>:</label>
                                        <InputMask
                                            type="text"
                                            id="cp_datanascimento"
                                            name="cp_datanascimento"
                                            mask="99/99/9999"
                                            value={userData.cp_datanascimento}
                                            onChange={handleChange}
                                            className={getFieldClassName("cp_datanascimento")}
                                            placeholder="dd/mm/aaaa"
                                            required
                                        />
                                        {renderFieldError("cp_datanascimento")}
                                    </Col>
                                    <Col md={12}>
                                        <label htmlFor="cp_estadocivil">Estado Civil:</label>
                                        <select
                                            id="cp_estadocivil"
                                            name="cp_estadocivil"
                                            value={userData.cp_estadocivil || ""}
                                            onChange={handleChange}
                                            className={getFieldClassName("cp_estadocivil")}
                                        >
                                            <option value="">Selecione...</option>
                                            <option value="solteiro">Solteiro(a)</option>
                                            <option value="casado">Casado(a)</option>
                                            <option value="divorciado">Divorciado(a)</option>
                                            <option value="viuvo">Viúvo(a)</option>
                                            <option value="uniao_estavel">União Estável</option>
                                        </select>
                                        {renderFieldError("cp_estadocivil")}
                                    </Col>

                                </Row>
                            </div>
                        </div>
                    </Col>

                    <Col md={6}>
                        {/* Coluna da Direita */}
                        <div className="card mb-3">
                            <div className="card-header">
                                <h6 className="card-title mb-0">Contato</h6>
                            </div>
                            <div className="card-body">
                                <Row className="gy-3">
                                    <Col md={12}>
                                        <label htmlFor="cp_whatsapp">WhatsApp:</label>
                                        <InputMask
                                            type="text"
                                            id="cp_whatsapp"
                                            name="cp_whatsapp"
                                            mask="(99) 99999-9999"
                                            value={userData.cp_whatsapp}
                                            onChange={handleChange}
                                            className={getFieldClassName("cp_whatsapp")}
                                            placeholder="WhatsApp"
                                        />
                                        {renderFieldError("cp_whatsapp")}
                                    </Col>
                                    <Col md={12}>
                                        <label htmlFor="cp_telefone">Telefone:</label>
                                        <InputMask
                                            type="text"
                                            id="cp_telefone"
                                            name="cp_telefone"
                                            mask="(99) 99999-9999"
                                            value={userData.cp_telefone}
                                            onChange={handleChange}
                                            className={getFieldClassName("cp_telefone")}
                                            placeholder="Telefone"
                                        />
                                        {renderFieldError("cp_telefone")}
                                    </Col>
                                </Row>
                            </div>
                        </div>

                        <div className="card mt-4 mb-3">
                            <div className="card-header">
                                <h6 className="card-title mb-0">Endereço</h6>
                            </div>
                            <div className="card-body">
                                <Row className="gy-3">
                                    <Col md={12}>
                                        <label htmlFor="cp_end_cidade_estado">Cidade e Estado:</label>
                                        <input
                                            type="text"
                                            id="cp_end_cidade_estado"
                                            name="cp_end_cidade_estado"
                                            value={userData.cp_end_cidade_estado}
                                            onChange={handleChange}
                                            className={getFieldClassName("cp_end_cidade_estado")}
                                            placeholder="Cidade e Estado"
                                        />
                                        {renderFieldError("cp_end_cidade_estado")}
                                    </Col>
                                    <Col md={12}>
                                        <label htmlFor="cp_end_rua">Rua:</label>
                                        <input
                                            type="text"
                                            id="cp_end_rua"
                                            name="cp_end_rua"
                                            value={userData.cp_end_rua}
                                            onChange={handleChange}
                                            className={getFieldClassName("cp_end_rua")}
                                            placeholder="Rua"
                                        />
                                        {renderFieldError("cp_end_rua")}
                                    </Col>
                                    <Col md={12}>
                                        <label htmlFor="cp_end_num">Número:</label>
                                        <input
                                            type="text"
                                            id="cp_end_num"
                                            name="cp_end_num"
                                            value={userData.cp_end_num}
                                            onChange={handleChange}
                                            className={getFieldClassName("cp_end_num")}
                                            placeholder="Número"
                                        />
                                        {renderFieldError("cp_end_num")}
                                    </Col>
                                    <Col md={12}>
                                        <label htmlFor="cp_end_cep">CEP:</label>
                                        <InputMask
                                            type="text"
                                            id="cp_end_cep"
                                            name="cp_end_cep"
                                            mask="99999-999"
                                            value={userData.cp_end_cep}
                                            onChange={handleChange}
                                            className={getFieldClassName("cp_end_cep")}
                                            placeholder="CEP"
                                        />
                                        {renderFieldError("cp_end_cep")}
                                    </Col>
                                    <Col md={12}>
                                        <label htmlFor="cp_descricao">Descrição:</label>
                                        <input
                                            type="text"
                                            id="cp_descricao"
                                            name="cp_descricao"
                                            value={userData.cp_descricao}
                                            onChange={handleChange}
                                            className={getFieldClassName("cp_descricao")}
                                            placeholder="Descrição"
                                        />
                                        {renderFieldError("cp_descricao")}
                                    </Col>
                                </Row>
                            </div>
                        </div>

                        <div className="card mt-4 mb-3">
                            <div className="card-header">
                                <h6 className="card-title mb-0">Empresa</h6>
                            </div>
                            <div className="card-body">
                                <Row className="gy-3">
                                    <Col md={12}>
                                        <label>
                                            <input
                                                type="checkbox"
                                                checked={isEmpresa}
                                                onChange={(e) => setIsEmpresa(e.target.checked)}
                                                className="form-check-input"
                                            />
                                            Cadastro de Empresa
                                        </label>
                                    </Col>
                                    {isEmpresa && (
                                        <>
                                            <Col md={12}>
                                                <label htmlFor="cp_cnpj">CNPJ:</label>
                                                <InputMask
                                                    type="text"
                                                    id="cp_cnpj"
                                                    name="cp_cnpj"
                                                    mask="99.999.999/9999-99"
                                                    value={userData.cp_cnpj}
                                                    onChange={handleChange}
                                                    className={getFieldClassName("cp_cnpj")}
                                                    placeholder="CNPJ"
                                                />
                                                {renderFieldError("cp_cnpj")}
                                            </Col>
                                            <Col md={12}>
                                                <label htmlFor="cp_ie">IE:</label>
                                                <input
                                                    type="text"
                                                    id="cp_ie"
                                                    name="cp_ie"
                                                    value={userData.cp_ie}
                                                    onChange={handleChange}
                                                    className={getFieldClassName("cp_ie")}
                                                    placeholder="IE"
                                                />
                                                {renderFieldError("cp_ie")}
                                            </Col>
                                            <Col md={12}>
                                                <label htmlFor="cp_empresaatuacao">Empresa de Atuação:</label>
                                                <input
                                                    type="text"
                                                    id="cp_empresaatuacao"
                                                    name="cp_empresaatuacao"
                                                    value={userData.cp_empresaatuacao}
                                                    onChange={handleChange}
                                                    className={getFieldClassName("cp_empresaatuacao")}
                                                    placeholder="Empresa de Atuação"
                                                />
                                                {renderFieldError("cp_empresaatuacao")}
                                            </Col>
                                            <Col md={12}>
                                                <label htmlFor="cp_profissao">Profissão:</label>
                                                <input
                                                    type="text"
                                                    id="cp_profissao"
                                                    name="cp_profissao"
                                                    value={userData.cp_profissao}
                                                    onChange={handleChange}
                                                    className={getFieldClassName("cp_profissao")}
                                                    placeholder="Profissão"
                                                />
                                                {renderFieldError("cp_profissao")}
                                            </Col>
                                        </>
                                    )}
                                </Row>
                            </div>
                        </div>


                    </Col>
                </Row>

                <div className="mt-4 text-center">
                    <button type="button" className="btn btn-outline-secondary me-2" onClick={goBack}>
                        Voltar
                    </button>
                    <button type="button" className="btn btn-primary" onClick={handleShowModal}>
                        {userId ? "Salvar Edição" : "Cadastrar Usuário"}
                    </button>

                </div>
            </form>
            <Modal show={showModal} onHide={handleCloseModal} centered>
                <Modal.Header closeButton>
                    <Modal.Title>{userId ? "Confirmar Edição" : "Confirmar Cadastro"}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {userId ? "Tem certeza que deseja salvar as alterações deste usuário?" : "Tem certeza que deseja cadastrar este usuário?"}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseModal}>
                        Cancelar
                    </Button>
                    <Button variant="primary" onClick={handleSubmit}>
                        {userId ? "Salvar Alterações" : "Cadastrar"}
                    </Button>
                </Modal.Footer>
            </Modal>


        </div>
    );

};

export default CadastroUsuarioModal;
